<template>
  <transition name="slideout">
    <div
      v-show="slideoutCartIsOpen"
      class="cart-slideout-wrapper flex items-center justify-center"
      :class="{ 'no-free-shipping-promo': !freeShipping.enabled, 'cart-slideout-wrapper--updating': cartIsUpdating }"
      data-close
      @click="closeSlideoutCart($event)"
    >
      <div class="cart-slideout">
        <div
          class="cart-slideout__header flex items-center"
          :class="{empty: cartIsEmpty}"
        >
          <ShippingPromo
            v-if="!cartIsEmpty && freeShipping.enabled"
            class="grow"
            :cart-total-price="totalPrice"
          />
          <button
            class="close-btn xs font-semibold flex items-center"
            data-close
            @click="closeSlideoutCart($event)"
          >
            <CloseIcon />
          </button>
        </div>
        <EmptyText v-if="cartIsEmpty" />
        <template v-else>
          <div class="cart-slideout__main">
            <FreeGiftPromo
              v-if="freeGift.enabled"
              :cart-total-price="totalPrice"
            />
            <ul class="cart-slideout__items">
              <SlideoutCartItem
                v-for="item in items"
                :key="item.id"
                :item="item"
              />
            </ul>
          </div>
          <div
            v-if="slideoutCartIsOpen"
            class="cart-slideout__upsells"
          >
            <UpsellMinicart />
          </div>
          <div
            class="cart-slideout__footer"
            :class="{ 'cart-slideout__footer--us': isUsStore }"
          >
            <ul
              v-if="customsCharge.enabled"
              class="cart-summary-list"
            >
              <li class="cart-summary-list__item">
                {{ strings.subtotalTitle }}
                <span class="font-bold">{{ subtotalExclCustomsFormatted }}</span>
              </li>
              <CustomsChargeSummaryRow />
              <li class="cart-summary-list__item">
                {{ strings.shippingTitle }}
                <span>{{ strings.shippingAtCheckout }}</span>
              </li>
            </ul>
            <CartSummaryList :cart-total-price="totalPrice" />
          </div>
        </template>
      </div>
      <UpsellPopup />
    </div>
  </transition>
</template>


<script>
import {useCartStore} from '../pinia/CartStore'
import {mapState, mapActions} from 'pinia'
import { isVennAppsWebView } from '../helpers/venn-apps'
import { productPrice } from '../helpers/product'

import EmptyText from './cart/empty-text'
import ShippingPromo from './cart/shipping-promo'
import FreeGiftPromo from './cart/free-gift-promo'
import SlideoutCartItem from './cart/slideout-cart-item'
import CartSummaryList from './cart/cart-summary-list'
import UpsellMinicart from './upsell-minicart'
import UpsellPopup from './upsell-popup'

import CloseIcon from '../icons/close-icon'

export default {
  components: {
    EmptyText,
    ShippingPromo,
    FreeGiftPromo,
    CloseIcon,
    SlideoutCartItem,
    CartSummaryList,
    UpsellMinicart,
    UpsellPopup
  },
  props: {},
  data() {
    return {
      freeShipping: {...window.theme.cart.freeShipping},
      freeGift: {...window.theme.cart.freeGift},
      customsCharge: {...(window.theme.cart.customsCharge || {})},
      strings: {...window.theme.cart.strings},
      routes: {...window.theme.cart.routes},
    }
  },
  computed: {
    ...mapState(useCartStore, [
      'items',
      'itemCount',
      'totalPrice',
      'subtotalExcludingCustoms',
      'cartIsUpdating',
      'slideoutCartIsOpen',
      'cartIsEmpty'
    ]),
    subtotalExclCustomsFormatted () {
      return productPrice(this.subtotalExcludingCustoms)
    },
    isUsStore() {
      return window.theme.shop.permanentDomain === 'sneak-gaming.myshopify.com'
    }
  },
  async mounted() {
    await this.getCart()
    this.addedToCartListener()
  },
  methods: {
    ...mapActions(useCartStore, [
      'getCart',
      'openSlideoutCart',
      'closeSlideoutCart',
      'clearCart'
    ]),
    addedToCartListener() {
      document.addEventListener('cartItemAdded', async () => {
        await this.getCart()
        if (!isVennAppsWebView()) {
          this.openSlideoutCart()
        }
      })
    }
  }
}
</script>
